/**
 * apiBase — where the app's server-side proxies live at runtime.
 * ---------------------------------------------------------------------------
 * Two Oracle/reader endpoints CAN'T be called directly from the browser: the
 * Oracle LLM proxy (the Anthropic key must stay server-side) and the article
 * reader (publishers send no CORS headers). They go through /api/oracle and
 * /api/article, which are:
 *
 *   - in `npm run dev` (and the phone loading the dev server over LAN): served
 *     by the Vite middleware at the SAME origin → API_BASE is '' → relative.
 *   - in the packaged APK bundle (no dev server): served by the deployed
 *     Cloudflare Pages Functions → set VITE_API_BASE at build time to that
 *     origin (e.g. https://f1-central.pages.dev) so these calls resolve to the
 *     hosted functions instead of 404'ing against appassets.androidplatform.net.
 *
 * If VITE_API_BASE is unset, API_BASE is '' and the packaged app simply falls
 * back (Oracle → offline catalogue, reader → feed summary) — nothing breaks;
 * the backend just isn't wired yet. See DEPLOY.md.
 *
 * NOTE: Jolpica (results/standings) and OpenF1 are CORS-open, so they are
 * called DIRECTLY (see jolpicaClient.js) and deliberately do NOT go through
 * here — direct is simpler and avoids a needless hop.
 *
 * import.meta.env is undefined under plain Node (the test scripts import the
 * clients), so read it with optional chaining and default to relative.
 */
const API_BASE = (import.meta.env?.VITE_API_BASE ?? '').replace(/\/+$/, '');

/** Prefix a proxy path with the configured base (absolute in a packaged build). */
export function apiUrl(path) {
  return `${API_BASE}${path}`;
}

export { API_BASE };
